// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolCleaningRequirementId } from './HarvestProtocolCleaningRequirement';
import { cleaningFieldId } from './CleaningField';
import { z } from 'zod';
export const cleaningRequirementCpSettingId = (z.number());
export const cleaningRequirementCpSetting = z.object({
    id: cleaningRequirementCpSettingId,
    cleaning_requirement_id: harvestProtocolCleaningRequirementId,
    cleaning_field_id: cleaningFieldId,
    number_target: z.string().nullable(),
    number_rel_tol_upper: z.string().nullable(),
    number_rel_tol_lower: z.string().nullable(),
    number_abs_tol_upper: z.string().nullable(),
    number_abs_tol_lower: z.string().nullable(),
    number_unit: z.string().nullable(),
    check_value: z.boolean().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const cleaningRequirementCpSettingInitializer = z.object({
    id: cleaningRequirementCpSettingId.optional(),
    cleaning_requirement_id: harvestProtocolCleaningRequirementId,
    cleaning_field_id: cleaningFieldId,
    number_target: z.string().optional().nullable(),
    number_rel_tol_upper: z.string().optional().nullable(),
    number_rel_tol_lower: z.string().optional().nullable(),
    number_abs_tol_upper: z.string().optional().nullable(),
    number_abs_tol_lower: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const cleaningRequirementCpSettingMutator = z.object({
    id: cleaningRequirementCpSettingId.optional(),
    cleaning_requirement_id: harvestProtocolCleaningRequirementId.optional(),
    cleaning_field_id: cleaningFieldId.optional(),
    number_target: z.string().optional().nullable(),
    number_rel_tol_upper: z.string().optional().nullable(),
    number_rel_tol_lower: z.string().optional().nullable(),
    number_abs_tol_upper: z.string().optional().nullable(),
    number_abs_tol_lower: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=CleaningRequirementCpSetting.js.map